export default {
  name: 'AssayShader',
  uniforms: {
    uColors: {
      value: [],
    },
    uRadius: {
      value: 4,
    },
    uLightPositions: { value: [] },
    uLightIntensities: { value: [1, 1] },
    uAmbientIntensity: { value: 0.8 },
  },
  vertexShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_vertex>
    uniform vec3 uColors[15];
    uniform float uRadius;
    attribute float colorIndex;
    varying vec2 vUv;
    varying vec3 vColor;
    varying float vColorIndex;
    varying vec3 vNormal;

    void main() {
      vUv = uv;
      float boundedIndex = step(0.0, colorIndex) * colorIndex;
      vColor = uColors[int(boundedIndex)];
      vColorIndex = colorIndex;
      vNormal = normal;

      vec3 radiusAdjustedPosition = position + normal * (uRadius - 1.0); // assume cylinders were created with radius of 1.0

      gl_Position = projectionMatrix * modelViewMatrix * vec4(radiusAdjustedPosition, 1.0 );
      #include <logdepthbuf_vertex>
    }`,
  fragmentShader: /* glsl */ `
    #include <common>
    #include <logdepthbuf_pars_fragment>
    uniform vec3 uLightPositions[2];
    uniform float uLightIntensities[2];
    uniform float uAmbientIntensity;
    varying vec2 vUv;
    varying vec3 vColor;
    varying float vColorIndex;
    varying vec3 vNormal;

    void main() {
      #include <logdepthbuf_fragment>
      if (vColorIndex < 0.0) {
        discard;
      }

      vec3 baseColor = vColor;
      vec3 color = vec3(0.0);
      for (int i = 0; i < 2; i++) {
        float lightIntensity = max(dot(normalize(vNormal), normalize(uLightPositions[i])), 0.0);
        color += baseColor * lightIntensity * uLightIntensities[i];
      }

      float ambientLightIntensity = 0.8;
      color += baseColor * uAmbientIntensity;
      
      gl_FragColor = vec4(color, 1.0);
    }`,
}
